/**
 * Utility function to open the Chattrik chat widget
 */
export const openChat = () => {
  try {
    // Check if Chattrik widget is loaded
    if (window.CD360 && typeof window.CD360.openChat === 'function') {
      window.CD360.openChat();
    } else if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') {
      window.$chatwoot.toggle('open');
    } else {
      // Fallback: try to trigger click on chat widget button if it exists
      const chatButton = document.querySelector('#cd360-snippet') || 
                        document.querySelector('[data-chattrik]') ||
                        document.querySelector('.chattrik-launcher');
      if (chatButton) {
        chatButton.click();
      } else {
        console.warn('Chat widget not found. Please ensure the Chattrik script is loaded.');
      }
    }
  } catch (error) {
    console.error('Error opening chat widget:', error);
  }
};
